/** A row read at one of several locations shown, carrying where it came from. */
export type Located<T> = T & { at: string };

/** Two records are the same thing when their names match, ignoring case and spacing. */
export const nameKey = (name: string): string => name.trim().toLowerCase().replace(/\s+/g, " ");

export interface Grouped<T> {
  key: string;
  first: Located<T>;
  copies: Located<T>[];
  ats: string[];
}

/** Rows that share a name become one, keeping the order the first of each came in. */
export function groupByName<T>(
  rows: readonly Located<T>[],
  name: (row: T) => string,
): Grouped<T>[] {
  const groups = new Map<string, Grouped<T>>();
  for (const row of rows) {
    const key = nameKey(name(row));
    const found = groups.get(key);
    if (found === undefined) groups.set(key, { key, first: row, copies: [row], ats: [row.at] });
    else {
      found.copies.push(row);
      if (!found.ats.includes(row.at)) found.ats.push(row.at);
    }
  }
  return [...groups.values()];
}
